import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  connect(){
    $(this.element).find('.image-show').modal('show');
  }
}

